import React, { Component } from 'react'

import PropertySelectorComponent from '../PropertySelectorComponent'

import JsonViewComponent from '../../../components/JsonViewComponent'
import BlockTest from '../BlockTest'
import BlockSetupCustomSteps from '../BlockSetupCustomSteps'
import TextInput from './TextInput'
import LongInput from './LongInput'
import ToggleInput from './ToggleInput'
import MergeSteps from '../MergeSteps'
import DateTimeInput from './DateTimeInput'
import ArrayInput from './ArrayInput'
import FieldSelect from './FieldSelect'
import { parseFields } from './DragDropHelpers'

class BlockSetupInput extends Component {
    state = {
        value: undefined
    }

    constructor() {
        super()
        this.onPropertySelect = this.onPropertySelect.bind(this)
        this.onPropertyLoaded = this.onPropertyLoaded.bind(this)
        this.onPropertyInput = this.onPropertyInput.bind(this)
        this.onMappingChanged = this.onMappingChanged.bind(this)
    }

    static getDerivedStateFromProps(props, state) {
        if (props.value && props.value.value) {
            state.value = props.value.value
        } else {
            state.value = props.value
        }
        state.step = props.step
        state.property = props.params
        return state
    }

    updatePropertyState = (value) => {
        this.setState({ value })
        this.props.onChange(this.props.step.id, value)
    }

    onPropertySelect = (selectedProperty) => {
        this.updatePropertyState(selectedProperty);
    }

    onPropertyInput = (property) => {
        const currentStep = this.props.step

        if (currentStep.regex !== undefined && property && property.trim() !== "") {
            const re = new RegExp(currentStep.regex, "g")
            const match = re.exec(property)
            property = { value: property }
            const entries = Object.entries(currentStep.outputs);
            if (match) {
                if (currentStep.outputs !== undefined && match !== undefined && match.length === entries.length + 1 /*for the full match*/) {
                    for (let [key, value] of entries) {
                        property[key] = match[value.group]
                    }
                }
            }
        }

        this.updatePropertyState(property);
    }

    onPropertyLoaded = (value) => {
        //let newState = { nextStepDisabled: false }
        this.updatePropertyState(value);
    }

    onMappingChanged = (mappings) => {
        this.updatePropertyState(mappings);
    }

    render() {
        const currentStep = this.props.step
        let path = currentStep.path;

        if (path && this.props.accountId) {
            path += (path.includes('?') ? '&' : "?") + "accountId=" + this.props.accountId
        }
        let result

        let ready = true

        if (path && currentStep.pathParamsFromStorage !== undefined) {
            let concat = path.includes('?') ? '&' : "?"
            for (let i = 0; i < currentStep.pathParamsFromStorage.length; i++) {
                const pathParam = currentStep.pathParamsFromStorage[i]
                if (this.props.block.params) {
                    const values = this.props.block.params[pathParam.step]
                    if (values) {
                        if (pathParam.property) {
                            path = path + concat + pathParam.name + '=' + encodeURIComponent(values[pathParam.property])
                        } else {
                            path = path + concat + pathParam.name + '=' + encodeURIComponent(values)
                        }
                        concat = "&"
                    } else {
                        ready = false
                    }
                } else {
                    ready = false
                }
            }
        }

        if (!ready) {
            return <></>
        }
        else if (currentStep.type === "input") {
            result = <TextInput onChange={this.onPropertyInput} value={this.state.value} inputTypes={this.props.inputTypes} required={currentStep.required} />
        }
        else if (currentStep.type === "inputhtml") {
            result = <TextInput onChange={this.onPropertyInput} value={this.state.value} inputTypes={this.props.inputTypes} keepHtml={true} required={currentStep.required} />
        }
        else if (currentStep.type === "inputlong") {
            result = <LongInput onChange={this.onPropertyInput} value={this.state.value} inputTypes={this.props.inputTypes} required={currentStep.required} />
        }
        else if (currentStep.type === "inputnumber") {
            result = <LongInput onChange={this.onPropertyInput} value={this.state.value} inputTypes={this.props.inputTypes} required={currentStep.required} />
        }
        else if (currentStep.type === "inputdatetime") {
            result = <DateTimeInput onChange={this.onPropertyInput} value={this.state.value} inputTypes={this.props.inputTypes} required={currentStep.required} />
        }
        else if (currentStep.type === "inputdate") {
            result = <DateTimeInput onChange={this.onPropertyInput} value={this.state.value} inputTypes={this.props.inputTypes} required={currentStep.required} onlyDate={true} />
        }
        else if (currentStep.type === "inputsimple") {
            let inputsimpleClassName = "form-control"
            if (currentStep.required && (!this.state.value  || this.state.value.trim() === "")) {
                inputsimpleClassName += " invalid"
            }
            result = <div className="d-flex">
                <input type="text" className={inputsimpleClassName}
                    value={this.state.value}
                    onChange={(e) => this.onPropertyInput(e.target.value)}
                    onBlur={(e) => this.onPropertyInput(e.target.value)}/>
            </div>
        }
        else if (currentStep.type === "toggle") {
            result = <ToggleInput onChange={this.onPropertyInput} value={this.state.value} inputTypes={this.props.inputTypes} />
        }
        else if (currentStep.type === "fields") {
            result = <FieldSelect key={currentStep.id} onChange={(v) => this.onPropertyInput({ items: v })} value={this.state.value ? this.state.value.items : undefined} inputTypes={this.props.inputTypes} />
        }
        else if (currentStep.type === "field") {
            if (this.props.inputTypes) {
                let inputType = this.props.inputTypes[0];
                if (currentStep.dataTypes && currentStep.dataTypes[0] === "array") {
                    if (inputType && this.state.value && this.state.value.items) {
                        const parsedFields = parseFields(this.state.value.items)
                        if (parsedFields && parsedFields.length === 1) {
                            const field = inputType.fields.find(a => a.id === parsedFields[0].id)
                            if (field) {
                                let itemType = field.itemtype
                                result = <>
                                    <FieldSelect key={currentStep.id} onChange={(v) => this.onPropertyInput({ items: v })} value={this.state.value.items} inputTypes={this.props.inputTypes} dataTypes={currentStep.dataTypes} single={true}/>
                                    <br />Item identifier (used to detect the items in the following blocks)
                                    <FieldSelect key={currentStep.id} onChange={(v) => this.onPropertyInput({ items: this.state.value.items, id: v })} value={this.state.value.id} inputTypes={[itemType]} single={true}/>
                                </>
                            }
                        }
                    }
                    if (!result) {
                        result = <FieldSelect key={currentStep.id} onChange={(v) => this.onPropertyInput({ items: v })} value={this.state.value} inputTypes={this.props.inputTypes} dataTypes={currentStep.dataTypes} single={true}/>
                    }
                } else {
                    result = <FieldSelect key={currentStep.id} onChange={(v) => this.onPropertyInput({ field: v })} value={this.state.value ? this.state.value.field : this.state.value } inputTypes={this.props.inputTypes} dataTypes={currentStep.dataTypes} single={true} />
                }
            }
        }
        else if (currentStep.type === "array") {
            result = <ArrayInput block={this.props.block} onChange={this.onPropertyInput} value={this.state.value} inputTypes={this.props.inputTypes} step={currentStep} itemType={currentStep.field.items} accountId={this.props.accountId} />
        }
        else if (currentStep.type === "test") {
            result = <BlockTest path={path} onTested={this.props.onChange} block={this.props.block} step={currentStep} />
        }
        else if (currentStep.type === "custom") {
            result = <BlockSetupCustomSteps path={path} parameters={currentStep.params} fields={currentStep.fields} block={this.props.block} stepId={currentStep.id} onChange={this.props.onChange} value={this.state.value} inputTypes={this.props.inputTypes} accountId={this.props.accountId} />
        }
        else if (currentStep.type === "json") {
            result = <JsonViewComponent path={path} onLoaded={this.onPropertyLoaded} />
        }
        else if (currentStep.type === "template") {
            result = <JsonViewComponent json={result} onLoaded={this.onPropertyLoaded} />
        }
        else if (currentStep.type === "select") {
            result = <PropertySelectorComponent path={path} onSelect={this.onPropertySelect} selected={this.state.value} items={currentStep.items} mapping={currentStep} />
        }
        else if (currentStep.type === "daterange") {
            //TODO: 
            const items = [
                {
                    "id": "currentweek",
                    "name": "Current week"
                },
                {
                    "id": "lastweek",
                    "name": "Last week"
                },
                {
                    "id": "currentmonth",
                    "name": "Current month"
                },
                {
                    "id": "lastmonth",
                    "name": "Last month"
                },
                // {
                //     "id": "ever",
                //     "name": "Ever (all existing items)"
                // },
                // {
                //     "id": "new",
                //     "name": "New items only (the first run will include none)"
                // }
            ]

            result = <PropertySelectorComponent onSelect={this.onPropertySelect} selected={this.state.value} items={items} />
        }
        else if (currentStep.type === "merge") {
            result = <MergeSteps path={path} block={this.props.block} stepId={currentStep.id} onChange={this.onMappingChanged} value={this.state.value} inputTypes={this.props.inputTypes} workflow={this.props.workflow} />
        }

        return <div id={currentStep.id}>
            {currentStep.label}
            {currentStep.description ? <><br/><small>{currentStep.description}</small></>
                : ""}
            {result}
        </div>
    }
}

export default BlockSetupInput
